<template>
  <div id="app">
    <b-navbar type="dark" variant="dark" fixed="top">
      <button class="btn navbar-toggler-right" v-b-toggle.sidebar type="button" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
    </b-navbar>
    <router-view/>
    <b-sidebar id="sidebar" bg-variant="black" text-variant="light">
      <div class="px-3 text-center">
        <b-img-lazy thumbnail width="140" fluid :src="avatar" rounded="circle" alt="Josué Cámara" />
        <h5 class="mt-3">Josué Cámara Fdez</h5>
        <div>
          <b-button pill class="mr-1" target="_blank" href="https://twitter.com/picharras">
            <font-awesome-icon :icon="['fab', 'twitter']" />
          </b-button>
          <b-button pill class="mr-1" target="_blank" href="https://linkedin.com/in/jcamara">
            <font-awesome-icon :icon="['fab', 'linkedin-in']" />
          </b-button>
          <b-button pill class="mr-1" target="_blank" href="https://gitlab.com/picharras">
            <font-awesome-icon :icon="['fab', 'gitlab']" />
          </b-button>
          <b-button pill class="mr-1" target="_blank" href="https://github.com/picharras">
            <font-awesome-icon :icon="['fab', 'github']" />
          </b-button>
          <b-button pill target="_blank" href="https://listadomedico.com">
            <font-awesome-icon :icon="['fas', 'stethoscope']" />
          </b-button>
        </div>
      </div>
      <template v-slot:footer>
        <div class="text-center text-light align-items-center px-3 py-2">
          <strong class="mr-auto">hola<span class="text-muted">@</span><span class="text-primary">josuecamara.me</span></strong>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo: {
    title: 'Josué Cámara',
    titleTemplate: '%s | Software Developer'
  },
  data () {
    return {
      avatar: require('./assets/avatar.jpg')
    }
  }
}
</script>
